import React from 'react'
import { getCoreRowModel, useReactTable } from '@tanstack/react-table'
import { Badge } from '@/components/ui/badge'
import { DataTableRowActions, DataTableRowText } from '../data-table-row-action'
import { CheckCircledIcon, CrossCircledIcon } from '@radix-ui/react-icons'
import { Card, CardContent } from '@/components/ui/card'
import MyDataTable from 'components/ui/my-data-table'
import Loader from '@/components/ui/Loader'
import useSWR from 'swr'
import DataTableToolbar from '../data-table-toolbar'
import { openTemplatesByPublisher } from 'commons/worksLinks'

export default function RealUsers() {
  const {
    data = [],
    isLoading,
    isValidating,
    mutate,
  } = useSWR(['/publishers', { role: ['admin', 'designer'] }])

  const columns = [
    {
      header: '#',
      cell: ({ row }) => row.index + 1,
    },
    {
      header: 'User name',
      accessorKey: 'username',
    },
    {
      header: 'Nick name',
      accessorKey: 'nick_name',
      cell: ({ row }) => <DataTableRowText row={row} entityKey="nick_name" />,
    },
    {
      header: 'Template count',
      accessorKey: 'templateCount',
      cell: ({ row }) => (
        <button
          type="button"
          className="font-medium underline underline-offset-4"
          onClick={() => openTemplatesByPublisher(row.original.id)}
        >
          {row.original.templateCount ?? 0}
        </button>
      ),
    },
    {
      header: 'Frame count',
      accessorKey: 'frameCount',
      cell: ({ row }) =>
        row.original.frameCount ?? row.original.onlineTemplateCount ?? 0,
    },
    {
      header: 'Role',
      accessorKey: 'roles',
      cell: ({ row }) => (
        <>
          {row.original?.roles?.map((role, index) => (
            <Badge variant="outline" key={index}>
              <small>{role}</small>
            </Badge>
          ))}
        </>
      ),
    },
    {
      header: 'State',
      accessorKey: 'state',
      cell: ({ row }) => (
        <>
          {row.original?.state === 0 ? (
            <CheckCircledIcon color="green" />
          ) : (
            <CrossCircledIcon color="red" />
          )}
        </>
      ),
    },
    {
      header: 'Actions',
      cell: ({ row }) => (
        <DataTableRowActions row={row} worksTarget="templates" />
      ),
    },
  ]

  const table = useReactTable({
    data: data,
    columns,
    enableRowSelection: false,
    getRowId: (row) => row.id,
    getCoreRowModel: getCoreRowModel(),
  })

  return (
    <div className="flex h-[calc(100vh-150px)] flex-col">
      {isLoading || isValidating ? (
        <Loader>Loading Users...</Loader>
      ) : (
        <>
          <div className="mb-2 flex-shrink-0">
            <DataTableToolbar mutate={mutate} role={'admin'} />
          </div>
          <div className="min-h-0 flex-1">
            <Card className="h-full overflow-y-auto">
              <CardContent className="pr-0">
                <MyDataTable table={table} />
              </CardContent>
            </Card>
          </div>
        </>
      )}
    </div>
  )
}
